import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=140ff247&scoped=true"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ff247",
  null
  
)

export default component.exports